import { useState } from 'react';
import type { FilterOption } from '../../-types';
import { FilterItem } from './filter-item';

interface ExpandableFilterListProps {
  items: FilterOption[];
  initialItemCount?: number;
}

export function ExpandableFilterList({ items, initialItemCount = 5 }: ExpandableFilterListProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const alwaysVisible = items.slice(0, initialItemCount);
  const overflowItems = items.slice(initialItemCount);
  const hasMoreItems = overflowItems.length > 0;

  return (
    <div>
      {alwaysVisible.map((item) => (
        <FilterItem key={item.id} {...item} />
      ))}

      {hasMoreItems && (
        <div
          className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${isExpanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
        >
          <div className="overflow-hidden">
            {overflowItems.map((item) => (
              <FilterItem key={item.id} {...item} />
            ))}
          </div>
        </div>
      )}

      {hasMoreItems && (
        <button
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-3 mb-2 flex items-center justify-center gap-2 w-full py-2 px-4 text-xs font-medium rounded-lg bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-950/40 dark:to-indigo-950/40 border border-blue-200 dark:border-blue-700/60 transition-all duration-300 hover:shadow-md hover:shadow-blue-500/20 dark:hover:shadow-blue-400/30 hover:from-blue-100 hover:to-indigo-100 dark:hover:from-blue-900/60 dark:hover:to-indigo-900/60 hover:border-blue-300 dark:hover:border-blue-500/80 expand-button"
        >
          <span className="text-blue-700 dark:text-blue-300 transition-colors duration-300">
            הצג {isExpanded ? 'פחות' : 'יותר'}
          </span>
          <div
            className={`expand-icon flex items-center justify-center w-4 h-4 rounded-full bg-blue-200 dark:bg-blue-800/80 text-blue-700 dark:text-blue-300 transition-all duration-300 ${
              isExpanded ? 'rotate-180' : ''
            }`}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              aria-hidden="true"
              role="presentation"
            >
              <path
                d="M3 4.5L6 7.5L9 4.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </button>
      )}
    </div>
  );
}
